<nav class="d-flex justify-content-center align-items-center">
  <ul
    class="container d-flex justify-content-center align-items-center"
    *ngIf="isUserAuthenticated && currentUser && isUserInfoDisplayed"
  >
    <li class="menu-item" (click)="goHome()">
      <i-feather name="home"></i-feather>
    </li>

    <ng-container *ngFor="let item of MENU">
      <li
        class="menu-item"
        [class.is-route-active]="item.label === routeActiveItem?.label"
        *appHasAccess="item.requiredRoles"
        (mouseenter)="activeItem = item"
        (mouseleave)="activeItem = null"
      >
        <span *ngIf="!item.route.length" class="item-text">
          {{ item.label }}
        </span>
        <a
          *ngIf="!item.v2 && item.route.length"
          [attr.href]="item.route"
          class="item-text"
        >
          {{ item.label }}
        </a>

        <a
          *ngIf="item.v2 && item.route.length"
          [routerLink]="item.route"
          class="item-text"
        >
          {{ item.label }}
        </a>

        <ul *ngIf="item?.subMenu?.length && activeItem === item">
          <li class="submenu-item" *ngFor="let subItem of item.subMenu">
            <a
              *ngIf="!subItem.v2; else submenuv2link"
              class="submenu-text"
              [attr.href]="subItem.route"
            >
              {{ subItem.label }}
            </a>

            <ng-template #submenuv2link>
              <a class="submenu-text" [routerLink]="subItem.route">
                {{ subItem.label }}
              </a>
            </ng-template>
          </li>
        </ul>
      </li>
    </ng-container>
  </ul>
</nav>
